export enum Permission {
    READ_ALL = 1,

    READ_COCKPIT = 1 << 1,
    READ_KAUTION_CONTRACTS = 1 << 2,
    READ_BUERGSCHEINE = 1 << 3,
    READ_DOWNLOADS = 1 << 4,
    READ_POSTEINGANG = 1 << 5,
    READ_MEINE_DATEN = 1 << 6,
    READ_MEINE_DATEN_PROFIL = 1 << 7,
    READ_MEINE_DATEN_JAHRESABSCHLUSS = 1 << 8,
    READ_MEINE_DATEN_MAKLERMANDAT = 1 << 9,
    READ_MEINE_DATEN_BENUTZERVERWALTUNG = 1 << 10,

    READ_FIRMENVERBUENDE = 1 << 11,

    READ_BENUTZERVERWALTUNG = 1 << 12,
    READ_VERMITTLERDATEN = 1 << 13,

    READ_FOREIGN_DATEN = 1 << 14,
    READ_FOREIGN_DATEN_PROFIL = 1 << 15,
    READ_FOREIGN_DATEN_JAHRESABSCHLUSS = 1 << 16,

    READ_OBLIGO = 1 << 17,

    READ_CREATE_BS = 1 << 18,

    READ_HILFE = 1 << 19,

    BE_MAKLER = 1 << 28,
    BE_STBR = 1 << 29,
    BE_MAKLER_OR_STBR = 1 << 30

}

export enum Role {
    KUNDEN_ADMIN = Permission.READ_COCKPIT
        | Permission.READ_KAUTION_CONTRACTS
        | Permission.READ_BUERGSCHEINE
        | Permission.READ_OBLIGO
        | Permission.READ_CREATE_BS
        | Permission.READ_DOWNLOADS
        | Permission.READ_POSTEINGANG
        | Permission.READ_MEINE_DATEN
        | Permission.READ_MEINE_DATEN_PROFIL
        | Permission.READ_MEINE_DATEN_JAHRESABSCHLUSS
        | Permission.READ_MEINE_DATEN_MAKLERMANDAT
        | Permission.READ_MEINE_DATEN_BENUTZERVERWALTUNG
        | Permission.READ_BENUTZERVERWALTUNG
        | Permission.READ_FIRMENVERBUENDE
        | Permission.READ_HILFE,

    KUNDE = Permission.READ_COCKPIT
        | Permission.READ_KAUTION_CONTRACTS
        | Permission.READ_BUERGSCHEINE
        | Permission.READ_OBLIGO
        | Permission.READ_CREATE_BS
        | Permission.READ_DOWNLOADS
        | Permission.READ_POSTEINGANG
        | Permission.READ_MEINE_DATEN
        | Permission.READ_MEINE_DATEN_PROFIL
        | Permission.READ_MEINE_DATEN_JAHRESABSCHLUSS
        | Permission.READ_HILFE,

    MAKLER = Permission.BE_MAKLER_OR_STBR
        | Permission.BE_MAKLER
        | Permission.READ_VERMITTLERDATEN
        | Permission.READ_HILFE,

    STEUERBERATER = Permission.BE_MAKLER_OR_STBR
        | Permission.BE_STBR
        | Permission.READ_VERMITTLERDATEN
        | Permission.READ_HILFE,
}

export enum EnhancedRights {
    KUNDEN_ADMIN = 0,

    KUNDE = 0,

    MAKLER = Permission.READ_COCKPIT
        | Permission.READ_KAUTION_CONTRACTS
        | Permission.READ_BUERGSCHEINE
        | Permission.READ_OBLIGO
        | Permission.READ_CREATE_BS
        | Permission.READ_DOWNLOADS
        | Permission.READ_FOREIGN_DATEN
        | Permission.READ_FOREIGN_DATEN_PROFIL
        | Permission.READ_FOREIGN_DATEN_JAHRESABSCHLUSS
        | Permission.READ_HILFE,

    STEUERBERATER = Permission.READ_BUERGSCHEINE
        | Permission.READ_KAUTION_CONTRACTS
        | Permission.READ_OBLIGO
        | Permission.READ_FOREIGN_DATEN
        | Permission.READ_FOREIGN_DATEN_PROFIL
        | Permission.READ_FOREIGN_DATEN_JAHRESABSCHLUSS
        | Permission.READ_HILFE,
}

export class RoleHandler {
    static names = [
        {
            handle: 'KP_KU-ADMIN',
            role: Role.KUNDEN_ADMIN,
            enhanced: EnhancedRights.KUNDEN_ADMIN,
            serverEnum: 'KP_KU_ADMIN',
            ldapIdentifier: 4
        },
        {
            handle: 'KP_KU-NUTZER',
            role: Role.KUNDE,
            enhanced: EnhancedRights.KUNDE,
            serverEnum: 'KP_KU_NUTZER',
            ldapIdentifier: 3
        }, {
            handle: 'KP_MAKLER',
            role: Role.MAKLER,
            enhanced: EnhancedRights.MAKLER,
            serverEnum: 'KP_MAKLER',
            ldapIdentifier: 6
        }, {
            handle: 'KP_STEUERBERATER',
            role: Role.STEUERBERATER,
            enhanced: EnhancedRights.STEUERBERATER,
            serverEnum: 'KP_STEUERBERATER',
            ldapIdentifier: 5
        }
    ];

    static qualifyUser(roleName: string): Role {
        for (const n of RoleHandler.names) {
            if (n.handle === roleName) {
                return n.role | n.enhanced;
            }
        }

        return null;
    }

    static isMaklerOrStbr(roleName: string): boolean {
        for (const n of RoleHandler.names) {
            if (n.handle === roleName) {
                return (n.role & Permission.BE_MAKLER_OR_STBR) === Permission.BE_MAKLER_OR_STBR;
            }
        }
        return false;
    }

    static isMaklerOrStbrRole(role: Role): boolean {
        return (role & Permission.BE_MAKLER_OR_STBR) === Permission.BE_MAKLER_OR_STBR;
    }

    static isMaklerRole(role: Role): boolean {
        return (role & Permission.BE_MAKLER) === Permission.BE_MAKLER;
    }

    static isSteuerberaterRole(role: Role): boolean {
        return (role & Permission.BE_STBR) === Permission.BE_STBR;
    }

    static getRole(roleName: string): Role {
        for (const n of RoleHandler.names) {
            if (n.handle === roleName) {
                return n.role;
            }
        }

        return null;
    }

    static handleFromEnum(serverEnum: string): string | null {
        for (const n of RoleHandler.names) {
            if (n.serverEnum === serverEnum) {
                return n.handle;
            }
        }
        return null;
    }

    static handleFromEnums(serverEnums: string[]): string | null {
        for (const serverEnum of serverEnums) {
            const found = RoleHandler.handleFromEnum(serverEnum);
            if (found != null) {
                return found;
            }
        }
        return null;
    }

    static handleFromLdapIdentifiers(ids: number[]): string | null {
        for (const id of ids) {
            const found = RoleHandler.handleFromLdapIdentifier(id);
            if (found != null) {
                return found;
            }
        }
        return null;
    }

    static handleFromLdapIdentifier(id: number): string | null {
        for (const role of RoleHandler.names) {
            if (role.ldapIdentifier == id) {
                return role.handle;
            }
        }
        return null;
    }

}
